import { Helpers } from '../../helpers';
import { IProjectAttachmentType } from '../../interfaces/iproject-attachment-type';
import { ProjectEstimate } from '../project-estimate';

export class ProjectAttachmentTypeBase {
  ProjectAttachmentTypeId: number;
  Description: string | null;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ProjectEstimates_ProjectAttachmentType?: Array<ProjectEstimate> | null;

  constructor(item?: IProjectAttachmentType) {
    if (item) {

      this.ProjectAttachmentTypeId = item.ProjectAttachmentTypeId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ProjectEstimates_ProjectAttachmentType = Helpers.createClassArray(ProjectEstimate, item.ProjectEstimates_ProjectAttachmentType);
    }
  }
}